import { isBizNull } from "../../utils";
import { S_PDP_LCC, S_PDP_ORDER_SUMMARY_DICTIONARIES, S_PDP_SHIPPING, webStorage } from "../../utils/webStorage";

export const PDP_ACTION_SEGMENT = "PDP";
const __ = key => `${PDP_ACTION_SEGMENT}_${key}`;
export const PDP_CHECKOUT_PROGRESS = __("CHECKOUT_PROGRESS");
export const PDP_DIFF_ADDR = __("DIFF_ADDR");
export const PDP_ORDER_PREVIEW = __("ORDER_PREVIEW");
export const PDP_DELIVERY = __("PDP_DELIVERY");
export const PDP_SUMMARY = __("SUMMARY");
export const PDP_SHIPPING = __("SHIPPING");
export const PDP_BILLING = __("BILLING");
export const PDP_PERSONAL_INFO = __("PERSONAL_INFO");
export const PDP_TOUCH_POINT = __("TOUCH_POINT");
export const PDP_BUNDLE = __("BUNDLE");
export const PDP_LCC = __("LCC");
export const PDP_PLANTYPE = __("PLANTYPE");
export const PDP_STOCK = __("STOCK");
export const PDP_MARKET = __("MARKET");
export const PDP_LOAN_LEADS_DATA = __("LOAN_LEADS_DATA");
export const PDP_LOAN_ORDER_STATUS = __("LOAN_ORDER_STATUS");
export const CLEAR_PDP_BUNDLE = __("CLEAR_BUNDLE");
export const CLEAR_PDP_LCC = __("CLEAR_LCC");
export const CLEAR_PDP_PLANTYPE = __("CLEAR_PLANTYPE");
export const CLEAR_PDP_SUMMARY = __("CLEAR_SUMMARY");
export const CLEAR_PDP = __("CLEAR");
export const CLEAR_PDP_LOAN_LEADS_DATA = __("CLEAR_LOAN_LEADS_DATA");
export const PDP_RISK_CHECK = __("RISK_CHECK");
export function setPdpMarketAction(payload) {
  return {
    type: PDP_MARKET,
    payload
  };
}
export function setPdpCheckoutProgressAction(payload) {
  return {
    type: PDP_CHECKOUT_PROGRESS,
    payload
  };
}
export function setPdpDiffAddrAction(payload) {
  return {
    type: PDP_DIFF_ADDR,
    payload
  };
}
export function setPdpLoanLeadsDataAction(payload) {
  return {
    type: PDP_LOAN_LEADS_DATA,
    payload
  };
}
export function setPdpOrderOreviewAction(payload) {
  return {
    type: PDP_ORDER_PREVIEW,
    payload
  };
}
export function setPdpDeliveryAction(payload) {
  return {
    type: PDP_DELIVERY,
    payload
  };
}
export function setPdpSummaryAction(payload) {
  return {
    type: PDP_SUMMARY,
    payload
  };
}
export function setPdpShippingAction(payload) {
  return {
    type: PDP_SHIPPING,
    payload
  };
}
export function setPdpPersonalInfoAction(payload) {
  return {
    type: PDP_PERSONAL_INFO,
    payload
  };
}
export function setPdpBillingAction(payload) {
  return {
    type: PDP_BILLING,
    payload
  };
}
export function setPdpTouchPointAction(payload) {
  return {
    type: PDP_TOUCH_POINT,
    payload
  };
}

export function setPdpBundleAction(payload) {
  return {
    type: PDP_BUNDLE,
    payload
  };
}
export function setPdpLccAction(payload) {
  return {
    type: PDP_LCC,
    payload
  };
}
export function setPdpPlanTypeAction(payload) {
  return {
    type: PDP_PLANTYPE,
    payload
  };
}
export function setPdpStockAction(payload) {
  return {
    type: PDP_STOCK,
    payload
  };
}
export function setPdpLoanOrderStatusAction(payload) {
  return {
    type: PDP_LOAN_ORDER_STATUS,
    payload
  };
}
export function clearPdpBundleAction() {
  return {
    type: CLEAR_PDP_BUNDLE
  };
}
export function clearPdpLccAction() {
  return {
    type: CLEAR_PDP_LCC
  };
}
export function clearPdpPlanTypeAction() {
  return {
    type: CLEAR_PDP_PLANTYPE
  };
}
export function clearPdpSummaryAction() {
  return {
    type: CLEAR_PDP_SUMMARY
  };
}
export function clearPdpLoanLeadsDataAction() {
  return {
    type: CLEAR_PDP_LOAN_LEADS_DATA
  };
}
export function clearPdpAction() {
  return {
    type: CLEAR_PDP
  };
}
export function setPdpRiskCheckAction(payload) {
  return {
    type: PDP_RISK_CHECK,
    payload
  };
}
